module.exports = __webpack_public_path__ + "static/media/icon-arrow-left.e7395235.svg";